<template>
  <div class="infographic-container" :aria-label="label">
    <div
      v-for="brainNetwork in brainNetworks"
      :key="brainNetwork.imageName"
      class="brain-network-container">
      <div class="text-container">
        <p class="title">{{ brainNetwork.title }}:</p>
        <p class="sub-title">THE <span :class="`keyword keyword-${brainNetwork.keyword}`">{{ brainNetwork.keyword }} </span> OF LEARNING</p>
      </div>
      <img
        :src="require(`@/assets/${brainNetwork.imageName}.svg`)"
        class="infographic-image"
        alt=""
        role="presentation" >
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      brainNetworks: [
        {
          imageName: 'udl-why',
					title: 'Affective Networks',
          keyword: 'why',
        },
        {
          imageName: 'udl-what',
					title: 'Recognition Networks',
          keyword: 'what',
        },
        {
          imageName: 'udl-how',
					title: 'Strategic Networks',
          keyword: 'how',
        },
      ],
			label: 'Universal Design for Learning and the three different brain networks: Affective Networks: The why of Learning, Recognition Networks: The what of Learning, Strategic Networks: The how of Learning'
    };
  },
};
</script>

<style lang="less" scoped>
.infographic-container {
  display: flex;
	justify-content: center;
	align-items: flex-start;
	text-align: left;
}
.brain-network-container {
	margin: 0 var(--spacing-md);
}
.text-container {
	text-transform: uppercase;
	margin-bottom: var(--spacing-xs);
	color: var(--gray-weak);
	letter-spacing: 0.16px;
}
.title {
  font-size: var(--text-3xs);
	margin: 0;
}
.sub-title {
  font-size: var(--text-xxs);
}
.keyword {
	font-weight: 700;
}
.keyword-why {
  color: #078743;
}
.keyword-what {
  color: #6F5094;
}
.keyword-how {
  color: #037DB8;
}
.infographic-image {
	width: 100%;
	max-width: 170px;
	max-height: 160px;
}

@media (max-width: 768px) {
	.title {
		font-size: var(--text-sm);
	}
	.sub-title {
		font-size: var(--text-lg)
	}
	.brain-network-container {
		margin: 0 var(--spacing-xl);
}
}
</style>
